import React, {Component} from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import MenuMobile from './MenuMobile';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: [],
        };
    }

    async componentDidMount() {
        try {
            const response = await axios.get('https://shop.mybadge.co.in/api/apiv1/menu');
            const resVal = response.data;
            if (resVal.status === 'success') {
                this.setState({ menu: resVal.data });
            }
        } catch (error) {
            console.error(error);
        }

        const script = document.createElement("script");
        script.async = true;
        script.src = "/assets/js/main.js";
        document.body.appendChild(script);
    }

    render() {
        return (
            <>
                <footer
                    className="ps-footer ps-footer--natureway"
                    style={{ backgroundImage: "url('/assets/img/footer.png')" }}
                >
                    <div className="container">
                        <div className="ps-footer__grid">
                            <div className="ps-footer__brand">
                                <Link to="/" className="ps-footer__logo">
                                    <img src="/assets/img/footer-logo.png" alt="Nature Way" />
                                </Link>
                                <div className="ps-footer__newsletter">
                                    <h4 className="ps-footer__heading">Subscribe to our newsletter</h4>
                                    <form className="ps-footer__newsletter-form" action="#" method="post">
                                        <input type="email" placeholder="Email" aria-label="Email address" />
                                        <button type="submit" aria-label="Subscribe">
                                            <i className="fa fa-arrow-right"></i>
                                        </button>
                                    </form>
                                </div>
                            </div>

                            <div className="ps-footer__links">
                                <div className="ps-footer__column">
                                    <h4 className="ps-footer__column-title">Quick Links</h4>
                                    <ul className="ps-footer__list">
                                        <li><Link to="/">Shop</Link></li>
                                        <li><Link to="/trackorders">Track Order</Link></li>
                                        <li><Link to="/compare">Compare</Link></li>
                                        <li><Link to="/">Our Story</Link></li>
                                        <li><Link to="/">Blog</Link></li>
                                        <li><Link to="/">Corporate Info</Link></li>
                                        <li><Link to="/contactus">Contact Us</Link></li>
                                    </ul>
                                </div>

                                <div className="ps-footer__column">
                                    <h4 className="ps-footer__column-title">Policies</h4>
                                    <ul className="ps-footer__list">
                                        <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                                        <li><Link to="/deliveryinfo">Shipping Policy</Link></li>
                                        <li><Link to="/refundpolicy">Refund Policy</Link></li>
                                        <li><Link to="/terms">Terms of Service</Link></li>
                                        <li><Link to="/">Sitemap</Link></li>
                                    </ul>
                                </div>

                                <div className="ps-footer__column ps-footer__column--help">
                                    <h4 className="ps-footer__column-title">Need Help?</h4>
                                    <Link to="/contactus" className="ps-footer__contact-btn">
                                        <span>Contact Us</span>
                                        <i className="fa fa-long-arrow-right"></i>
                                    </Link>
                                    <div className="ps-footer__socials">
                        <a href="https://www.facebook.com/Naturewaymartoil" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fa fa-facebook"></i></a>
                        <a href="https://www.instagram.com/natureway_oils/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fa fa-instagram"></i></a>
                        <a href="https://www.youtube.com/@naturewayagrofoodscosmetic3268" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fa fa-youtube-play"></i></a>
                    </div>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <div className="ps-footer__bottom">
                            <span className="ps-footer__bottom-line"></span>
                            <p>Copyright © 2026 Nature Way. All Rights Reserved</p>
                            <span className="ps-footer__bottom-line"></span>
                        </div>
                    </div>
                </footer>

                <MenuMobile menu={this.state.menu} />

                <button className="btn scroll-top"><i className="fa fa-angle-double-up"></i></button>

                <div className="ps-preloader" id="preloader">
                    <div className="ps-preloader-section ps-preloader-left"></div>
                    <div className="ps-preloader-section ps-preloader-right"></div>
                </div>
            </>
        );
    }
}

export default Footer;
